import { DeviceController } from './modules/device-controller';
import { LenisController }  from './modules/lenis-controller';
import { BarbaController }  from './modules/barba-controller';

// ブラウザの自動スクロール復元 (戻る/進むや hash 付き遷移) を無効化。
//   有効のままだと DOMContentLoaded 前の (画像未ロードで短い) レイアウトで
//   #hash 位置を測定してジャンプされ、後から画像がロードされてズレる。
//   自前で「画像ロード完了後に scroll する」流れに任せる。
if ( 'scrollRestoration' in history ) {
  history.scrollRestoration = 'manual';
}

document.addEventListener( 'DOMContentLoaded', () => {
  // ページを跨いで生き続ける global controller (1回きり)
  DeviceController.init();
  LenisController.init();

  // per-page な controller 群は BarbaController が管理する
  // (初回 initPage + barba のフック経由で SPA 遷移後も再初期化)
  BarbaController.init();

  // ============================================================
  // 初回ロード時 #hash ジャンプ
  // ------------------------------------------------------------
  // Barba 有効時: 下層 → front-page の SPA 遷移は barba のフック側で処理する。
  //   ここは「フルロードでハッシュ付き URL に来た初回」を担当。
  //   ブラウザのネイティブ hash ジャンプは DOMContentLoaded 前 (画像未ロード状態)
  //   の高さで位置を決めるため、下部セクションほど画像ロード後にズレる。
  //   → scrollRestoration=manual で自動ジャンプを止め、画像ロード後に自前で scroll する。
  // ============================================================
  const hash = window.location.hash ? window.location.hash.slice( 1 ) : '';
  if ( hash ) {
    const target = document.getElementById( hash );
    if ( target ) {
      const scrollToTarget = () => {
        LenisController.lenis?.resize?.();
        if ( LenisController.lenis ) {
          LenisController.lenis.scrollTo( target, { immediate: true, force: true } );
        } else {
          const y = target.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo( 0, y );
        }
        if ( typeof ScrollTrigger !== 'undefined' ) ScrollTrigger.refresh();
      };

      // 初回は Lenis 初期化直後に一度合わせておく (視覚的な暫定位置)
      scrollToTarget();

      // 全画像 (含: 未ロードのもの) が完了したら最終位置に合わせる。
      // ユーザーが既にスクロールしていたら邪魔しないよう、target 近辺に居るときだけ再スクロール。
      const NEAR_THRESHOLD = 400;
      const nearTarget = () => Math.abs( target.getBoundingClientRect().top ) < NEAR_THRESHOLD;

      const imgs = document.querySelectorAll( 'img' );
      const pending = [];
      imgs.forEach( ( img ) => {
        if ( !img.complete ) {
          pending.push( new Promise( ( res ) => {
            img.addEventListener( 'load',  res, { once: true } );
            img.addEventListener( 'error', res, { once: true } );
          } ) );
        }
      } );
      const runFinal = () => { if ( nearTarget() ) scrollToTarget(); };
      if ( pending.length ) {
        Promise.all( pending ).then( runFinal );
      }
      // window の load でも一応合わせる (フォント / 遅延 CSS 起因のシフト対応)
      if ( document.readyState !== 'complete' ) {
        window.addEventListener( 'load', runFinal, { once: true } );
      }
    }
  }
} );
